import React, { useState, useEffect } from 'react';
import { atlasClient } from '../../../api/atlasClient';
import { SparkProjectResource } from '../types/sparkTypes';
import styles from '../styles/MarketLogicDisplayCard.module.css';
// Assuming TextButton styles might be reused or adapted from ProjectInsightsWallPanel.module.css
// Or we might need dedicated buttons here
import parentStyles from '../styles/ProjectInsightsWallPanel.module.css'; // For button styles

import { DeleteIcon } from './icons/DeleteIcon'; // Import DeleteIcon

interface MarketLogicDisplayCardProps {
    resource: SparkProjectResource;
    onOpenRemoveConfirm: (resourceFqn: string | null, jobFqn: string | null, resourceTitle: string) => void;
    onOpenPdfLightbox: (fileId: string, title?: string) => void;
    onViewProfile: (profileFqn: string) => void;
}

const MarketLogicDisplayCard: React.FC<MarketLogicDisplayCardProps> = (
    { resource, onOpenRemoveConfirm, onOpenPdfLightbox, onViewProfile }
) => {
    const displayName = resource.title || resource.fqn || 'Market Logic Resource';
    const canRemove = !!resource.fqn || !!resource.job_fqn;
    const canViewPdf = !!resource.pdf_file_id;
    const isProcessing = !resource.is_ready;
    const hasHeroImage = !!resource.hero_image_id;
    const previewText = resource.comment || '';
    const [heroImageUrl, setHeroImageUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (resource.hero_image_id) {
            setHeroImageUrl(atlasClient.getAssetUrl(resource.hero_image_id, { full: true }));
        } else {
            setHeroImageUrl(undefined);
        }
    }, [resource.hero_image_id]);

    const handleCardClick = () => {
        if (isProcessing) return;

        if (canViewPdf && resource.pdf_file_id) {
            onOpenPdfLightbox(resource.pdf_file_id, displayName);
        } else if (resource.fqn) {
            onViewProfile(resource.fqn);
        }
    };

    const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation(); // Prevent card click
        if (canRemove) {
            onOpenRemoveConfirm(resource.fqn ?? null, resource.job_fqn ?? null, displayName);
        }
    };
    return (
        <li 
            className={`${styles.cardContainer} ${isProcessing ? styles.processingAnimation : ''}`}
            onClick={handleCardClick}
            title={isProcessing ? 'Processing...' : `View ${displayName}`}
        >
            {hasHeroImage && heroImageUrl && (
                <div className={styles.imageContainer}>
                    <img
                        src={heroImageUrl}
                        alt={displayName}
                        className={styles.heroImage}
                        loading="lazy"
                    />
                </div>
            )}
            
            <div className={styles.contentContainer}>
                <h3 className={styles.title}>{displayName}</h3>
                {previewText && (
                     <p className={styles.preview}>{previewText}</p>
                )}
                {isProcessing && (
                    <span className={styles.processingBadge}>Processing...</span>
                )}
                {/* <div className={styles.sourceBadge}>
                    <span className={styles.sourceBadgeIcon}><DeepSightsIcon fontSize="small"/></span>
                    <span className={styles.sourceBadgeText}>{contextText || 'DeepSights Profile'}</span>
                </div> */}
            </div>
            
            {/* Action buttons (visible on hover via CSS) */}
             {!isProcessing && (
                 <div className={styles.actionsContainer}>
                      <button
                          className={`${parentStyles.textButton} ${parentStyles.removeButton}`}
                          onClick={handleRemoveClick}
                          title={`Remove ${displayName}`}
                          disabled={!canRemove}
                      >
                          <DeleteIcon style={{ fontSize: '16px' }} />
                      </button>
                 </div>
             )}
        </li>
    );
};

export default MarketLogicDisplayCard; 
